// extracted by mini-css-extract-plugin
export default {"Rodape":"Rodape_Rodape__E27vi"};